module.exports = __webpack_public_path__ + "img/2023-31.0c547337.jpg";